export interface IJob {
  company: string;
  jobTitle: string;
  startDate: string;
  endDate: string;
  skills: string[];
  description: string[];
}

export const JobData: IJob[] = [
  {
    company: "Amazon",
    jobTitle: "Software Developer Engineer",
    startDate: "June 2026",
    endDate: "Present",
    skills: ["Java", "AWS", "CDK for IaC", "TypeScript", "DynamoDB"],
    description: ["I will be re-joining AWS after graduation!"],
  },
  {
    company: "Squarepoint Capital",
    jobTitle: "Software Developer Intern",
    startDate: "Sept 2025",
    endDate: "Dec 2025",
    skills: ["TBD"],
    description: [
      "Automated trading-critical configurations with Python to reduce manual configuration and ensure proper booking validation",
      "Documented and analyzed manual workflows to define requirements and validation steps for future automation",
    ],
  },
  {
    company: "Amazon",
    jobTitle: "Software Developer Intern",
    startDate: "May 2025",
    endDate: "Aug 2025",
    skills: ["Java", "AWS", "CDK for IaC", "TypeScript", "DynamoDB"],
    description: [
      "Developed a bill-analysis engine using Java to detect billing discrepancies, reducing manual investigation time by 80%",
      "Wrote AWS CDK code to deploy and configure AWS Lambda, DynamoDB and AWS Batch to allow easy region expansion",
      "Built a dynamic front-end that enables developers to display analysis results in different formats reducing development time",
      "Actively engaged in code reviews, leading to a 4x decrease in required revisions and higher code quality",
      "Used Amazon Bedrock to provide AI-generated explanations of billing discrepancies to improve user experience",
    ],
  },
  {
    company: "University of British Columbia",
    jobTitle: "Teaching Assistant",
    startDate: "Sept 2024",
    endDate: "Dec 2024",
    skills: ["Python", "Machine Learning", "Data Processing", "Communication"],
    description: [
      "CPSC 330: Applied Machine Learning.  Taught using Python, Numpy, Pandas, and SKLearn",
      "Held weekly tutorial sessions to imrpove student understanding of core concepts",
      "Assistant students in debugging their assignments and troubleshooting environment issues",
      "Graded assignments in a timely manner",
    ],
  },
  {
    company: "Cambio Earth Systems (BGC Engineering)",
    jobTitle: "Web Developer Co-op",
    startDate: "May 2023",
    endDate: "Sept 2024",
    skills: [
      "React",
      "C#",
      ".NET",
      "Typescript",
      "SQL",
      "Azure Functions & Service Bus",
      "CSS",
      "Git",
      "CI/CD",
      "Esri ArcGIS",
      "Agile Development",
    ],
    description: [
      "Spearheaded the development of a plethora of <strong>fullstack</strong> features for the company's geotechnical data management platform, used daily by hundreds of engineers, enhancing their daily operational efficiency and decision-making abilities",
      "Independently developed a plot to display <strong>NOAA National Water Model</strong> data using <strong>ChartJS</strong> allowing engineers to easily visualize time-series data integrated with hazard-site specific information",
      "Expanded the 'Admin Tool' UI to allow direct database modifications through <strong>Entity Framework</strong>, saving hundreds of hours of development time, reducing lead-times, and streamlining multiple processes to meet stakeholder needs",
      "Led a large-scale refactor, creating an intuitive interface that replaced manual code-based feature configuration, saving hundreds of development hours. Collaborated with stakeholders to define and integrate functional and technical requirements",
      "Undertook a major refactor of the internal token system, significantly enhancing application reliability by enabling continued functionality during external service outages, eliminating weekly downtime, and improving code quality and maintainability",
      "Led a team of developers as <strong>Scrum Master</strong>, collaborating with product owners, engineers, and stakeholders to define requirements, ensuring all tickets were aligned with client expectations and delivered to specification",
    ],
  },
  {
    company: "Cambio Earth Systems (BGC Engineering)",
    jobTitle: "QA & Test Automation Co-op",
    startDate: "Sept 2022",
    endDate: "May 2023",
    skills: [
      "Python",
      "Azure Pipelines",
      "Selenium",
      "PyTest",
      "Quality Assurance",
      "API Testing",
      "Test Pipeline Stabilization",
    ],
    description: [
      "Independently developed a test automation framework written in python using <strong>PyTest</strong> and <strong>Selenium</strong> which runs nightly on an <strong>Azure Pipeline</strong> to monitor system-critical apis and microservices reducing lead time by automating failure notification emails to the QA team",
      "Created and executed test plans using both automated and manual testing methods to verify backend cloud systems consisting of <strong>Azure Function Apps</strong>, <Strong>Service Buses</strong>, and <strong>SQL jobs/databases</strong> ensuring reliable system performance and correctness",
      "Refactored and updated existing <strong>python automations</strong> to respond to functional changes and to improve code quality and stability",
      "<strong>Co-ordinated 3 production releases</strong> of Cambio's flagship software, keeping track of testing progress and assuring all release deadlines were completed",
      "Implemented <strong>multi-threading</strong> for API tests, accelerating test execution by 400% and significantly reducing overall runtime.",
      "Built, refactored, and updated python automation tests to respond to functional changes and to improve code maintainability, expanding coverage to 80% of existing microservices, saving hundreds of hours of QA testing capacity.",
    ],
  },
  {
    company: "Cactus Club Cafe",
    jobTitle: "Line & Prep Cook",
    startDate: "Mar 2018",
    endDate: "Aug 2022",
    skills: ["Time Management", "Teamwork", "Leadership"],
    description: [
      "Assisted with training and leading new staff members.",
      "Executed dishes to order with attention to detail and consistency.",
      "Worked weekends part-time during school and full-time during breaks",
    ],
  },
];
